import { Box, styled } from '@mui/material'

export const paperStyles = {
  width: '100%',
  overflow: 'hidden',
  boxShadow: '0',
  paddingBottom: '5px',
  height: '100%',
}

export const filterActionsContainer = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
}

export const columnValueContainer = {
  flex: 1,
  minWidth: 0,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

export const expandableRowContainer = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexShrink: 0,
  marginLeft: '8px',
}

export const expandableRowCell = {
  paddingLeft: '10px',
  paddingRight: '20px',
  border: 'none',
  paddingTop: 0,
  paddingBottom: 0,
}

export const TableContainer = styled(Box)`
  padding: 0 8px;
  overflow: auto;
  height: 100%;
`
